import styled from 'particles/themes/styled'

export const PopperContainer = styled.div`
    width: fit-content;
    &.mobile-container {
        position: relative;
        width: 100%;
        height: fit-content;
        min-height: 209px;
        overflow-y: auto;
        overflow-x: hidden;
        background-color: ${({ theme }) => theme.colors.surface.primary};
        padding: 40px 16px 24px 16px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: ${({ theme }) => theme.spacing[600]};
        .close-icon {
            position: absolute;
            right: 16px;
            top: 16px;
        }
    }
`
export const MobileCommentContainer = styled.div`
    align-items: flex-end;
    height: 100vh;
    width: 100vw;
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 999;
    display: flex;
`

export const ThreadListContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    .thread-list-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .popper-comment-card {
        max-height: none;
    }
`
